import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./auth";
import { getTenant, getTenantByRoom } from "./apiService";

const TenantDetails = () => {
  const [tenantdetails, setTenantdetails] = useState([]);
  const navigate = useNavigate();
  const { roomid, guestId } = useAuth();

  useEffect(() => {
    getTenantByRoom(roomid).then((res) => {
      setTenantdetails(res);
      // console.log(roomdetails);
    });
  }, [roomid]);

  const handleEditGuest = (tenant) => {
    // console.log(tenant);
    guestId(tenant.id);
    navigate("EditGuest");
  };

  const handleDeleteGuest = (tenant) => {
    // console.log(tenant);
    guestId(tenant.id);
    navigate("DeleteGuest");
  };

  const handleVacateGuest = (tenant) => {
    guestId(tenant.id);
    navigate("VacateGuest");
  };

  return (
    <div className="container-box">
      <h3 className="header">Tenants Details</h3>
      <div className="table-container">
        <table className="table-cls">
          {/* <thead>
            <th>
              <tr>Tenant NAME</tr>
              <tr>Mobile No</tr>
              <tr>Aadhar No</tr>
              <tr>Joined Date</tr>
              <tr>Rent Amount</tr>
              <tr>Balance Amount</tr>
              <tr>Advance Amount</tr>
              <tr>Payment Date</tr>
              <tr>Action</tr>
            </th>
          </thead> */}
          <tbody>
            {tenantdetails.map((tenant) => {
              if (tenant.roomNo === roomid) {
                return (
                  <td key={tenant.id}>
                    <tr className="tab-cls">Name : {tenant.name}</tr>
                    <tr className="tab-cls">Mobile : {tenant.mobileno}</tr>
                    <tr className="tab-cls">Aadhar : {tenant.aadharNo}</tr>
                    <tr className="tab-cls">JoinDate : {tenant.joinedDate}</tr>
                    <tr className="tab-cls">RentAmt : {tenant.rentAmt}</tr>
                    <tr className="tab-cls">BalAmt : {tenant.balAmt}</tr>
                    <tr className="tab-cls">AdvAmt : {tenant.advAmt}</tr>
                    <tr className="tab-cls">Paydate : {tenant.paymentDate}</tr>
                    <tr>
                      <button onClick={() => handleEditGuest(tenant)}>
                        Edit
                      </button>
                      <button onClick={() => handleDeleteGuest(tenant)}>
                        Delete
                      </button>
                      <button onClick={() => handleVacateGuest(tenant)}>
                        Vacated
                      </button>
                    </tr>
                  </td>
                );
              }
              return null;
            })}
          </tbody>
        </table>
      </div>
      <Outlet />
    </div>
  );
};

export default TenantDetails;
